import Image from 'next/image'
import { PropsWithChildren } from 'react'

import mainBg from '@/assets/images/bg-gradient.webp'
import mainBgPattern from '@/assets/images/bg-grid-pattern.png'
import { useForceDarkThemeOnRender } from '@/hooks'

export const OnboardingLayout = ({ children }: PropsWithChildren) => {
  useForceDarkThemeOnRender()

  return (
    <main className="relative flex min-h-dvh flex-col bg-radial">
      <div className="pointer-events-none absolute -top-[28rem] right-1/2 h-[80rem] w-[113.125rem] max-w-full translate-x-1/2 touch-none overflow-visible">
        <Image
          priority
          src={mainBg}
          decoding="async"
          alt="Onboarding Background"
          sizes="100vw"
          className="h-full w-full overflow-visible opacity-50 rotate-180"
        />
      </div>
      <div className="pointer-events-none absolute -top-[3rem] right-1/2 opacity-80 h-[20rem] w-[60vw] max-w-full translate-x-1/2 touch-none overflow-visible">
        <Image
          src={mainBgPattern}
          decoding="async"
          alt="Onboarding Background Pattern"
          sizes="100vw"
          className="h-full w-full overflow-visible z-10 rotate-[8deg]"
        />
      </div>
      <div className="flex items-center justify-start p-4">
        <div className="flex h-[calc(100vh_-_40px)] w-full gap-x-2">
          {children}
        </div>
      </div>
    </main>
  )
}
